import React, { useEffect } from "react";
import "./reactErrorBoundary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { pathOr } from "ramda";
import { useDispatch } from "react-redux";
import { PDFCO_APP_ORIGIN } from "../../constants/common";
import { resetAppState } from "../../reducers/app/actions";

const ReactErrorBoundary = (error = "") => {
  const dispatch = useDispatch();

  useEffect(() => {}, [error]);

  return (
    <div className={"container-fluid PageWrap"}>
      <div>
        <div className={"ErrorTitle"}>
          <FontAwesomeIcon icon={faExclamationCircle} className={"ErrorIcon"} />
          <span>An unexpected error occurred! Please try again!</span>
        </div>
        {pathOr(false, ["error", "message"], error) && (
          <div className={"ErrorDescription mt-3"}>
            {error.error.message}

            <div className={"small mt-3"}>
              <a href={`${PDFCO_APP_ORIGIN}/logs/api`}>
                Check API logs for details
              </a>
            </div>
            <div className={"small"}>
              <a href="https://apidocs.pdf.co/kb">
                Explore PDF.co Knowledgebase
              </a>
            </div>
            <div className={"small"}>
              <a
                href={`https://support.bytescout.com/hc/en-us/requests/new?subject=Document%20Parser%20Template%20Editor%20${error.error.message}`}
              >
                Contact Customer Support
              </a>
            </div>
          </div>
        )}
        <div className={"ButtonWrap mt-3"}>
          <button
            className={"btn btn-primary Button"}
            onClick={() => {
              window.location.reload();
              dispatch(resetAppState());
            }}
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReactErrorBoundary;
